// ** React Imports
/* eslint-disable */
import { Link, Navigate } from 'react-router-dom'
import { Fragment, useEffect, useState } from 'react'
/* eslint-disable */
import * as Icon from 'react-feather'

import { useNavigate } from 'react-router-dom'
// ** Third Party Components
// import * as Icon from 'react-feather'
import { MessageSquare, ShoppingBag, CheckSquare, Book, Calendar} from 'react-feather'
import classnames from 'classnames'
// import {Todo} from '../../../../views/todo-list'
// ** Custom Component
import Autocomplete from '@components/autocomplete'
import { Sun, Moon } from 'react-feather'
// ** Reactstrap Imports
import {
  NavItem,
  NavLink,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledTooltip,
  UncontrolledDropdown
} from 'reactstrap'

// ** Store & Actions
import { useDispatch, useSelector } from 'react-redux'
import { getBookmarks, updateBookmarked, handleSearchQuery } from '@store/navbar'

const NavbarBookmarks = props => {
  const { setMenuVisibility } = props
  const navigate = useNavigate()
  const { skin, setSkin } = props

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }
  // ** Props
  // const { setMenuVisibility } = props

  // ** State
   const [value, setValue] = useState('')
  // const [openSearch, setOpenSearch] = useState(false)

  // ** Store Vars
  const dispatch = useDispatch()
  const store = useSelector(state => state.navbar)

  // ** ComponentDidMount
  useEffect(() => {
    dispatch(getBookmarks())
  }, [])


  // ** If user has more than 10 bookmarks then add the extra Bookmarks to a dropdown
  // const renderExtraBookmarksDropdown = () => {
  //   if (store.bookmarks.length && store.bookmarks.length >= 11) {
  //     return (
  //       <NavItem className='d-none d-lg-block'>
  //         <NavLink tag='span'>
  //           <UncontrolledDropdown>
  //             <DropdownToggle tag='span'>
  //               <Icon.ChevronDown className='ficon' />
  //             </DropdownToggle>
  //             <DropdownMenu end>
  //               {store.bookmarks
  //                 .map(item => {
  //                   const IconTag = Icon[item.icon]
  //                   return (
  //                     <DropdownItem tag={Link} to={item.link} key={item.id}>
  //                       <IconTag className='me-50' size={14} />
  //                       <span className='align-middle'>{item.title}</span>
  //                     </DropdownItem>
  //                   )
  //                 })
  //                 .slice(10)}
  //             </DropdownMenu>
  //           </UncontrolledDropdown>
  //         </NavLink>
  //       </NavItem>
  //     )
  //   } else {
  //     return null
  //   }
  // }

  // ** Removes query in store
  //const handleClearQueryInStore = () => dispatch(handleSearchQuery(''))

  // ** Loops through Bookmarks Array to return Bookmarks
  // const onKeyDown = e => {
  //   if (e.keyCode === 27 || e.keyCode === 13) {
  //     setTimeout(() => {
  //       setOpenSearch(false)
  //       handleClearQueryInStore()
  //     }, 1)
  //   }
  // }

  // ** Function to toggle Bookmarks
  //const handleBookmarkUpdate = id => dispatch(updateBookmarked(id))

  // ** Function to handle Bookmarks visibility
  // const handleBookmarkVisibility = () => {
  //   setOpenSearch(!openSearch)
  //   setValue('')
  //   handleClearQueryInStore()
  // }

  // ** Function to handle Input change
  // const handleInputChange = e => {
  //   setValue(e.target.value)
  //   dispatch(handleSearchQuery(e.target.value))
  // }

  // ** Function to handle external Input click
  // const handleExternalClick = () => {
  //   if (openSearch === true) {
  //     setOpenSearch(false)
  //     handleClearQueryInStore()
  //   }
  // }

  // ** Function to clear input value
  // const handleClearInput = setUserInput => {
  //   if (!openSearch) {
  //     setUserInput('')
  //     handleClearQueryInStore()
  //   }
  // }

  //handler for Support ticket
  const handleSupportTicket = () => {
    
    navigate(`/support-ticket/AddTicket`)
    // <ToDo/>
  }

   //handler for Order approval
  const handleOrder = () => {
    navigate(`/order-book/approval-pending`)
    // <ToDo/>
  }

   //handler for Payment approval
  const handlePayment = () => {
    navigate(`/payment-managment/approved-payments`)
    // <ToDo/>
  }

   //handler for Tada approval
  const handleTada = () => {
    navigate(`/tadaApproval`)
    // <ToDo/>
  }

   //handler for Calendar
  const handleCalendar = () => {
    navigate(`calendar`)
    // <ToDo/>
  }

  return (
    <Fragment>
      <ul className='navbar-nav d-xl-none'>
        <NavItem className='mobile-menu me-auto'>
          <NavLink className='nav-menu-main menu-toggle hidden-xs is-active' onClick={() => setMenuVisibility(true)}>
            <Icon.Menu className='ficon' />
          </NavLink>
        </NavItem>
      </ul>
      <ul className='nav navbar-nav bookmark-icons'>
        {/* {renderBookmarks()} */}
        {/* {renderExtraBookmarksDropdown()} */}
        
        {/* <NavItem className='nav-item d-none d-lg-block me-1'>
        <NavLink className='bookmark-star' id='supportTicketTooltip' onClick={handleSupportTicket}>
            <MessageSquare className='ficon ' size={20}/>
            <UncontrolledTooltip placement='bottom' target='supportTicketTooltip'>
        Support Ticket
      </UncontrolledTooltip>
          </NavLink>  */}
          {/* <Todo/> */}
       {/* </NavItem> */}
     
       {/* <NavItem className='nav-item d-none d-lg-block me-1'>
        <NavLink className='bookmark-star' id='order' onClick={handleOrder}>
            <ShoppingBag className='ficon ' size={20}/>
            <UncontrolledTooltip placement='bottom' target='order'>
       Order
      </UncontrolledTooltip>
          </NavLink>  */}
          {/* <Todo/> */}
       {/* </NavItem> */}

       {/* <NavItem className='nav-item d-none d-lg-block me-1'>
        <NavLink className='bookmark-star' id='payment' onClick={handlePayment}>
            <Book className='ficon ' size={20}/>
            <UncontrolledTooltip placement='bottom' target='payment'>
            Payment
      </UncontrolledTooltip>
          </NavLink>  */}
          {/* <Todo/> */}
       {/* </NavItem> */}

       {/* <NavItem className='nav-item d-none d-lg-block me-1'>
        <NavLink className='bookmark-star' id='tada' onClick={handleTada}>
            <CheckSquare className='ficon text-primary' size={20}/>
            <UncontrolledTooltip placement='bottom' target='tada'>
      TaDa
      </UncontrolledTooltip>
          </NavLink>  */}
          {/* <Todo/> */}
       {/* </NavItem> */}

       {/* <NavItem className='nav-item d-none d-lg-block'>
        <NavLink className='bookmark-star' id='calendar' onClick={handleCalendar}>
            <Calendar className='ficon text-primary' size={20}/>
            <UncontrolledTooltip placement='bottom' target='calendar'>
      Calendar
      </UncontrolledTooltip>
          </NavLink>  */}
          {/* <Todo/> */}
       {/* </NavItem> */}
       
       {/* <NavItem className='d-none d-lg-block'>
        <NavLink className='nav-link-style' id='theme'>
          <ThemeToggler />
          <UncontrolledTooltip placement='bottom' target='theme'>
      Theme
      </UncontrolledTooltip>
        </NavLink>
      </NavItem> */}
        {/* <NavItem className='nav-item d-none d-lg-block'>
          <NavLink className='bookmark-star' onClick={handleBookmarkVisibility}>
            <Icon.Star className='ficon text-warning' />
          </NavLink> */}
          {/* <div className={classnames('bookmark-input search-input', { show: openSearch })}>
            <div className='bookmark-input-icon'>
              <Icon.Search size={14} />
            </div>
            {openSearch && store.suggestions.length ? (
              <Autocomplete
                wrapperClass={classnames('search-list search-list-bookmark', {
                  show: openSearch
                })}
                className='form-control'
                suggestions={!value.length ? store.bookmarks : store.suggestions}
                filterKey='title'
                autoFocus={true}
                defaultSuggestions
                suggestionLimit={!value.length ? store.bookmarks.length : 6}
                placeholder='Search...'
                externalClick={handleExternalClick}
                clearInput={(userInput, setUserInput) => handleClearInput(setUserInput)}
                onKeyDown={onKeyDown}
                value={value}
                onChange={handleInputChange}
                customRender={(
                  item,
                  i,
                  filteredData,
                  activeSuggestion,
                  onSuggestionItemClick,
                  onSuggestionItemHover
                ) => {
                  const IconTag = Icon[item.icon ? item.icon : 'X']
                  return (
                    <li
                      key={i}
                      onMouseEnter={() => onSuggestionItemHover(filteredData.indexOf(item))}
                      className={classnames('suggestion-item d-flex align-items-center justify-content-between', {
                        active: filteredData.indexOf(item) === activeSuggestion
                      })}
                    >
                      <Link
                        to={item.link}
                        className='d-flex align-items-center justify-content-between p-0'
                        onClick={() => {
                          setOpenSearch(false)
                          handleClearQueryInStore()
                        }}
                        style={{
                          width: 'calc(90%)'
                        }}
                      >
                        <div className='d-flex justify-content-start align-items-center overflow-hidden'>
                          <IconTag size={17.5} className='me-75' />
                          <span className='text-truncate'>{item.title}</span>
                        </div>
                      </Link>
                      <Icon.Star
                        size={17.5}
                        className={classnames('bookmark-icon float-end', {
                          'text-warning': item.isBookmarked
                        })}
                        onClick={() => handleBookmarkUpdate(item.id)}
                      />
                    </li>
                  )
                }}
              />
            ) : null}
          </div> */}
        {/* </NavItem> */}
      </ul>
    </Fragment>
  )
}

export default NavbarBookmarks
